import { MotifSortieDto, ReferentielControllerApi } from 'lib_api/lib/api/gen';

export async function fetchMotifSortie(
  refController: ReferentielControllerApi,
): Promise<MotifSortieDto[]> {
  return refController.getValidMotifSortieUsingGET().then(response => {
    return response.referenceDtoList;
  });
}
